/**
 * CTA + dialog de evolução no prontuário. A lógica FHIR fica no hook;
 * EHRRecords monta o CTA no header e no summary via renderCta().
 */
import { useEffect, useState } from "react";
import { EvolutionButton } from "./EvolutionButton";
import { EvolutionConfirmDialog } from "./EvolutionConfirmDialog";
import { fetchEvolutionPatient } from "./evolutionPatient";
import { usePatientEvolution } from "./usePatientEvolution";

export function useEhrRecordsEvolution(
  patientId: string | undefined,
  enabled: boolean,
  fullWidth: boolean,
) {
  const [open, setOpen] = useState(false);
  const [patientDisplay, setPatientDisplay] = useState("");
  const {
    loading,
    hasOpenEvolution,
    peekOpenEvolution,
    startOrContinueFromPatientId,
    professionalDisplay,
  } = usePatientEvolution();

  useEffect(() => {
    if (!enabled || !patientId) return;
    peekOpenEvolution(patientId);
    fetchEvolutionPatient(patientId).then((patient) => {
      if (patient?.display) setPatientDisplay(patient.display);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, patientId]);

  const renderCta = () =>
    enabled ? (
      <EvolutionButton
        hasOpenEvolution={hasOpenEvolution}
        loading={loading}
        fullWidth={fullWidth}
        onClick={() => setOpen(true)}
      />
    ) : null;

  const dialog = (
    <EvolutionConfirmDialog
      open={open}
      patientDisplay={patientDisplay}
      professionalDisplay={professionalDisplay}
      hasOpenEvolution={hasOpenEvolution}
      loading={loading}
      onClose={() => setOpen(false)}
      onConfirm={async () => {
        if (!patientId) return;
        const ok = await startOrContinueFromPatientId(patientId);
        if (ok) setOpen(false);
      }}
    />
  );

  return { renderCta, dialog };
}
